export const EDIT_YARD_MAP = "EDIT_YARD_MAP";
export const EDIT_YARD_MAP_SUCCESS = "EDIT_YARD_MAP_SUCCESS";
export const EDIT_YARD_MAP_FAILURE = "EDIT_YARD_MAP_FAILURE";
export const CLEAR_ERROR_EDITING_YARD_MAP = "CLEAR_ERROR_EDITING_YARD_MAP";
